import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { NotaRemisionSifenPayloadService } from './nota-remision-sifen-payload.service';

@Module({
  imports: [PrismaModule],
  providers: [NotaRemisionSifenPayloadService],
  exports: [NotaRemisionSifenPayloadService],
})
export class NotaRemisionPayloadModule {}
